"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import ReactUtils from "../../react_utils";
const bem = ReactUtils.makeBem("stop-address");
function normalized(value) {
  return (value || "").trim().toLowerCase();
}
export function citiesAreUnique(stops) {
  if (_.some(stops, (stop) => normalized(stop == null ? void 0 : stop.city) === "")) {
    return false;
  }
  const keys = stops.map(
    (stop) => normalized(stop == null ? void 0 : stop.city) + "|" + normalized(stop == null ? void 0 : stop.state)
  );
  return _.uniq(keys).length === keys.length;
}
export function cityState(stop) {
  return _.compact([stop.city, stop.state]).join(", ");
}
export function cityStateZip(stop) {
  return _.compact([cityState(stop), stop.postal_code]).join(" ");
}
export function streetAndCity(stop) {
  return _.compact([stop.address_line_1, stop.address_line_2, stop.city]).join(
    ", "
  );
}
export default function StopAddress({ stop, cityOnly }) {
  if (cityOnly) {
    return /* @__PURE__ */ jsx("span", { className: bem("__city-only"), children: cityState(stop) });
  }
  const street = _.compact([stop.address_line_1, stop.address_line_2]).join(
    ", "
  );
  const city = cityStateZip(stop);
  return /* @__PURE__ */ jsxs("div", { className: bem(), children: [
    street && /* @__PURE__ */ jsx("div", { className: bem("__street"), children: street }),
    city && /* @__PURE__ */ jsx("div", { className: bem("__city"), children: city })
  ] });
}
